export const capitalizeFirstLetter = (text: string) => {
  const textLowerCase = text.toLowerCase()
  return textLowerCase.charAt(0).toUpperCase() + textLowerCase.slice(1)
}

export const formatToKebabCase = (text: string) => {
  return text.toLowerCase().replace(/\ /g, '-')
}
